import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./page.css";
import "./home.css";

const treks = [
  {
    to: "/trekking/kilimanjaro",
    title: "Mount Kilimanjaro",
    text: "Guided routes up Africa’s highest peak, paced for a steady ascent.",
  },
  {
    to: "/trekking/meru",
    title: "Mount Meru",
    text: "A scenic climb near Arusha, strong on its own or as preparation.",
  },
  {
    to: "/trekking/ol-dionyo-lengai",
    title: "Ol Doinyo Lengai",
    text: "A night ascent with ash slopes and a crater view at dawn.",
  },
];

function Trekking() {
  useEffect(() => {
    document.title = "Trekking · Mirrorkhan Tours";
  }, []);

  return (
    <section className="page section-block">
      <div className="container">
        <div className="row mb-4 mb-lg-5" data-reveal>
          <div className="col-lg-8">
            <p className="eyebrow">Trekking</p>
            <h1 className="mb-3">Tanzania’s mountain treks.</h1>
            <p className="page-lead mb-0">
              Guided mountain treks in Tanzania, planned at a human pace.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {treks.map((trek, index) => (
            <div
              className="col-md-6"
              key={trek.to}
              data-reveal
              style={{ "--reveal-delay": `${index * 90}ms` }}
            >
              <Link
                to={trek.to}
                className="tour-list-item d-block text-decoration-none h-100"
              >
                <div className="tour-list-item__body">
                  <h2 className="h3 mb-2">{trek.title}</h2>
                  <p className="mb-0">{trek.text}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Trekking;
